import React, {Component} from 'react';
import {Col, Row, Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

//CSS
import '../../../assets/css/ProductoStandart.css';


//assets
import dobleProducto from '../../../assets/img/productos/dobleProducto2.png';
import portada from '../../../assets/img/productos/mes.png';
import btnDescarga from '../../../assets/img/productos/btnDescarga.png';
import btnDescargaOsc from '../../../assets/img/productos/btnDescargaGrey.png';
import hr from '../../../assets/img/productos/hr.png';
import logo25 from '../../../assets/img/logo25prod.png';


//Import Components
import Galeria from '../../elementos/Galeria';
import SliderFinan from "../../elementos/SliderFinan";


//Import Imagenes Galeria
import foto1 from '../../../assets/img/galeria/mes/foto1.png';
import foto2 from '../../../assets/img/galeria/mes/foto2.png';
import foto3 from '../../../assets/img/galeria/mes/foto3.png';
import foto4 from '../../../assets/img/galeria/mes/foto4.png';

import valor1 from '../../../assets/img/valores/mes/valor1.png';
import valor2 from '../../../assets/img/valores/mes/valor2.png';


const photos = [
    {src: foto1, width: 4, height: 3},
    {src: foto2, width: 4, height: 3},
    {src: foto3, width: 4, height: 3},
    {src: foto4, width: 4, height: 3}
];

class ModuloSolido extends Component {

    componentDidMount() {
        document.title = "Modulo sólido - Sensor Tecnología";
        window.scrollTo(0, 0);
    }

    realiceSuConsulta(){
        var data =  {
            content_category: 'clics',
            content_name: 'bt-realice-consulta'
        };
        ReactPixel.track( 'Lead', data );

        ReactGA.event({
            action:'consultar',
            category: 'clics',
            label: 'bt-realice-consulta'
        });
    }

    render() {
        return (
            <div>
                <section className="productos productos-std">
                    <div className="home-producto">
                        <Row>
                            <Col md={6}>
                                <div className="img-producto">
                                    <img className="img-responsive" src={portada} alt=""/>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="tit-producto">
                                    <h1>
                                        <span>{this.context.t('Módulos de estado sólido')}</span>
                                        <img src={logo25} alt=""/>
                                        </h1>
                                    <img src={hr} alt=""/>
                                    <p>{this.context.t('Más inteligencia, más protección y más gestión de recursos.')}</p>
                                    <p className="tit-dsc">{this.context.t('Unidades inteligentes para control de potencia.')}</p>
                                    <p className="dsc">{this.context.t('Las unidades de control de potencia MES, sirven para evitar accidentes causados por negligencias o acciones fuera de lo recomendado. Las protecciones del sistema son realizadas de forma automática y generan al mismo tiempo, una alarma audiovisual que muestra la situación exacta que causó la acción.')}
                                    </p>
                                    <br/><br/>
                                    <Col md={6} className="no-padding-left">
                                        <Link to="/contacto" onClick={() => this.realiceSuConsulta()}>
                                            <Button>{this.context.t('Realice su consulta')}</Button>
                                        </Link>
                                    </Col>
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <div className="home-gallery">
                        <Galeria photos={photos}/>
                    </div>

                    <div className="productos-caracteristicas">
                        <div className="container-limit">
                            <Row>


                                <Col md={6}>
                                    <div className="caracteristicas-descripcion">
                                        <h3>{this.context.t('Información')}</h3>
                                        <div className="red-line3"></div>
                                        <p className="sinBorde">
                                            {this.context.t('Los módulos MES pueden medir el tiempo de uso de todo el sistema y de cada salida de forma individual, permitiendo saber con exactitud cómo y cuándo se utiliza cada función.')}
                                        </p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor1} alt=""/>
                                    </div>
                                </Col>


                            </Row>

                            <br/><br/>
                            <Row>
                                <Col md={6}>

                                    <div className="caracteristicas-descripcion" style={{marginTop: "60px"}}>
                                        <h3>{this.context.t('Excelente relación costo beneficio')}</h3>
                                        <div className="red-line3"></div>
                                        <p className="sinBorde">
                                            {this.context.t('La aplicación de los módulos permite reducir notablemente los costos vinculados a material eléctrico y simplificar la arquitectura eléctrica de la máquina.')}
                                        </p>
                                    </div>
                                </Col>

                                <Col md={6}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor2} alt=""/>
                                    </div>
                                </Col>

                            </Row>



                        </div>
                    </div>

                    <Row>
                        <div className="descargas">
                            <Row>
                                <Col md={12} className="bgGrey">
                                    <a target="_blank" href={process.env.PUBLIC_URL + "/archivos/mes/catalogo-mes.pdf"}>
                                        <div className="btnDescarga" style={{paddingTop:"5%",paddingBottom:"5%"}}>
                                            <img src={btnDescargaOsc} alt=""/>
                                            <div className="dscDescarga" style={{color: "#676868"}}>
                                                <h3>{this.context.t('Catálogo')}</h3>
                                                <h5>{this.context.t('MES | Módulo de Estado Sólido')}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    </Row>


                </section>

            </div>
        )
    }
}

export default ModuloSolido;